import { NormalizedError } from "services";

export const errorTypes = {
  SILENT: "SILENT",
};

export interface IDataError extends Error {
  data?: any;
}

export function createError(name: string, message: string, data?: any): IDataError {
  const newError: IDataError = new Error(message);

  newError.name = name;
  if (data) {
    newError.data = data;
  }

  return newError;
}

export const silentError = createError(errorTypes.SILENT, "");

export function isSilentError(error: IDataError): boolean {
  return error ? error.name === errorTypes.SILENT : false;
}

export function handleSilentError(error: IDataError) {
  if (error.name === "SILENT") {
    return Promise.resolve();
  }

  throw error;
}

export type HttpResponseError = Error & {
  response: {
    body: {
      error: string;
      text: string;
    };
  };
};

export function printError(error: any): string {
  if (typeof error === "string") {
    return error;
  }
  if (typeof error === "object") {
    if ("message" in error) {
      return error.message;
    }
  }
  return "";
}

// Функция для определения сетевых ошибок
export function isNetworkError(error: any): boolean {
  if (!error) return false;

  // Проверяем сообщение об ошибке на наличие ключевых фраз сетевых ошибок
  const errorMessage = String(error.message || "").toLowerCase();
  const networkErrorPhrases = [
    "request has been terminated",
    "network is offline",
    "failed to fetch",
    "network error",
    "connection refused",
    "connection timeout",
    "no internet connection",
    "offline",
    "network request failed",
  ];

  return networkErrorPhrases.some((phrase) => errorMessage.includes(phrase));
}

// Функция для создания нормализованной сетевой ошибки
export function createNetworkError(): NormalizedError {
  return {
    code: "NETWORK_ERROR",
    status: null,
    message: "Отсутствует соединение",
    detail: "Отсутствует соединение с интернетом",
    instance: "",
    title: "Отсутствует соединение",
    type: "network_error",
  };
}

// Функция для обработки ошибок fetch запросов
export function handleFetchError(error: any): NormalizedError {
  if (isNetworkError(error)) {
    return createNetworkError();
  }

  // Если это уже нормализованная ошибка, возвращаем как есть
  if (error && typeof error === "object" && "type" in error) {
    return error;
  }

  // Иначе создаем стандартную ошибку
  return {
    code: "UNKNOWN",
    status: null,
    message: "Произошла ошибка при загрузке данных",
    detail: error?.message || "Неизвестная ошибка",
    instance: "",
    title: "Ошибка загрузки",
    type: "unknown_error",
  };
}

export const parseErrorMessage = (error: NormalizedError) => {
  // Проверяем, является ли это сетевой ошибкой
  if (error && error.type === "network_error") {
    return "Отсутствует соединение";
  }

  return (error && (error.title || error.message || error.detail)) || "Произошла ошибка при загрузке данных";
};
